import Vue from 'vue'

import TextInput from './components/common/TextInput'
import FileInput from './components/common/FileInput'
import TextareaInput from './components/common/TextareaInput'
import SelectBox from './components/common/SelectBox'
import SelectBoxMulti from './components/common/SelectBoxMulti'
import CheckboxInput from './components/common/CheckboxInput'
import LiCheckboxInput from './components/common/LiCheckboxInput'
import RadioInput from './components/common/RadioInput'
import DatePicker from "@/components/common/DatePicker"
import SearchInput from "@/components/common/SearchInput"
import ListActionLine from "@/components/common/ListActionLine"
import FilterCheckbox from "@/components/common/FilterCheckbox"
import ListCheckboxInput from "@/components/common/ListCheckboxInput"
import RadioButton from "./components/common/RadioButton"
import Modal from "./components/common/Modal"
import RangeSlider from "./components/common/RangeSlider"
import MultiselectSearchbox from "./components/common/MultiselectSearchbox";

Vue.component('text-input', TextInput)
Vue.component('file-input', FileInput)
Vue.component('textarea-input', TextareaInput)
Vue.component('select-box', SelectBox)
Vue.component('select-box-multi', SelectBoxMulti)
Vue.component('checkbox-input', CheckboxInput)
Vue.component('li-checkbox-input', LiCheckboxInput)
Vue.component('radio-input', RadioInput)
Vue.component('date-picker', DatePicker)
Vue.component('search-input', SearchInput)
Vue.component('list-action-line', ListActionLine)
Vue.component('filter-checkbox', FilterCheckbox)
Vue.component('list-checkbox-input', ListCheckboxInput)
Vue.component('radio-button', RadioButton)
Vue.component('modal', Modal);
Vue.component('range-slider', RangeSlider);
Vue.component('multiselect-searchbox', MultiselectSearchbox);



// WEBPACK FOOTER //
// ./src/globalComponents.js